import React from 'react'

import { requestReauthentication } from '@/app/module/auth/store/session.slice'
import reAuthEvents, { REAUTH_REQUIRED_EVENT } from '@/app/service/util/re-auth-events'
import { useAppDispatch } from '@/app/store/redux-hooks'

type Props = {}

const ReAuthRequiredGate: React.FC<Props> = () => {
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    const handleReauthRequired = () => {
      dispatch(requestReauthentication())
    }

    reAuthEvents.on(REAUTH_REQUIRED_EVENT, handleReauthRequired)

    return () => {
      reAuthEvents.off(REAUTH_REQUIRED_EVENT, handleReauthRequired)
    }
  }, [dispatch])

  return null
}

export default ReAuthRequiredGate
